import { Injectable } from '@angular/core';
import { AuthTokenService } from './auth-token.service';
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(protected http: HttpClient,
              protected router: Router,
              protected authTokenService: AuthTokenService) { }

  login(username: string, password: string) {
    return this.http.post<any>(`${environment.identityApiUrl}login`, { username, password });
  }

  logout(): void {
    this.authTokenService.clearAll();
    this.router.navigate(['/']);
  }

   alterarSenha(dados: any) {  
  return this.http.post(`${environment.identityApiUrl}alterar-senha`, dados);
}
}
